// hooks
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';
import {useSelector} from "../redux/store";

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const {name, email, isAgencyUser} = useSelector((state) => state.user);

  return (
    <Avatar
      src=""
      alt={name}
      color={createAvatar(name).color}
      {...other}
    >
      {createAvatar(isAgencyUser ? email : name).name}
    </Avatar>
  );
}
